(function ($) {
  Drupal.behaviors.loyaltyOfferSignupV1 = {
    attached: false,
    attach: function () {
      if (this.attached) {
        return;
      }
      this.attached = true;

      $(document).on('cbox_complete', function () {
        const $body = $('body');
        const $popover = $body.find('.js-loyalty-popover');

        if ($body.find('.js-popup-enabled').length > 0) {
          $('body').addClass('non-intrusive-popup-enabled');
        }
        if ($popover.data('moveOptinsAbove') === 1) {
          $('body').addClass('shift-optins-above');
        }
        if ($popover.data('newsletterEnabled') === 1) {
          $('body').addClass('newsletter-with-loyalty');
        }
      });
    }
  };
})(jQuery, Drupal);
